export const shortenAddress = (address: string) => {
  if (address) {
    return (
      address?.substring(0, 4) +
      "..." +
      address?.substring(address.length - 3, address.length)
    );
  }
  return "";
};

export const shortenAddressLength = (address: string, length: number) => {
  if (address) {
    return (
      address?.substring(0, length) +
      "..." +
      address?.substring(address.length - length, address.length)
    );
  }
  return "";
};
